import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'

import {
  getStockDaysColor,
  getStockDaysStep,
  stockDaysSteps,
} from 'utilities/price-evaluation'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${({ theme }) => theme.sizeByFactor(0.75)};
  font-family: ${({ theme }) => theme.font};
  color: ${({ theme }) => theme.colors.text};
`

const Label = styled.span`
  font-size: ${({ theme }) => theme.baseFontSize};
  font-weight: 400;
  line-height: ${({ theme }) => theme.baseLineHeight};
  white-space: nowrap;
`

const Segments = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizeByFactor(0.375)};
`

const Segment = styled.span`
  display: block;
  width: ${({ theme }) => theme.sizings.lvl2};
  height: ${({ theme }) => theme.sizings.lvl1};
  background-color: ${({ theme, $color }) =>
    theme.colors[$color] || theme.colors.priceEvaluationNone};
`

/**
 * Number of days a car is in stock with a segmented indicator. Every 30 days
 * fills one more segment in the colour of the current step.
 */
const StockDaysIndicator = ({ days, className, ...restProps }) => {
  const { t } = useTranslation()
  const filledSegments = getStockDaysStep(days)
  const color = getStockDaysColor(days)

  return (
    <Container className={className} {...restProps}>
      <Label>{`${days} ${t('stayDays')}`}</Label>
      <Segments aria-hidden="true">
        {Array.from({ length: stockDaysSteps }, (_, index) => (
          <Segment
            key={index.toString()}
            $color={index < filledSegments ? color : undefined}
          />
        ))}
      </Segments>
    </Container>
  )
}

StockDaysIndicator.propTypes = {
  days: PropTypes.number.isRequired,
  className: PropTypes.string,
}

StockDaysIndicator.defaultProps = {
  className: null,
}

export default StockDaysIndicator
